module.exports = __webpack_public_path__ + "static/cognitive-psychology-69acf15899b27de98a76fe8dd2b0e529.png";